import { render } from "./AdminHolidayList.vue?vue&type=template&id=f0a8886e"
import script from "./AdminHolidayList.vue?vue&type=script&lang=js"
export * from "./AdminHolidayList.vue?vue&type=script&lang=js"

import exportComponent from "../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__